import type { CheckoutPage as CheckoutPageProps } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';

const CheckoutPageComponent: React.FC<CheckoutPageProps> = props => {
  return (
    <>
      <ContentArea
        components={props.aboveCheckoutContentArea}
        propertyName="AboveCheckoutPageContentArea"
      />
      <h1 className="heading-1">CHECKOUT PAGE PLACEHOLDER</h1>
      <ContentArea
        components={props.belowCheckoutContentArea}
        propertyName="BelowCheckoutPageContentArea"
      />
    </>
  );
};

const CheckoutPage = withNav(CheckoutPageComponent, true /*suppress nav*/);
export default CheckoutPage;
